import React from "react";
import { Switch, Form } from "antd";
import Icon from "@ant-design/icons";
import "./AdnLanguageSlider.css";

import { ReactComponent as fluencyPT } from "../../../assets/images/image_languages/icons8-portugal-48.svg";
import { ReactComponent as fluencyEN } from "../../../assets/images/image_languages/icons8-great-britain-48.svg";

const AdnLanguageSlider = ({ isEnglish, onLanguageSwitch, name, label, disabled }) => {
  return (
    <div className="language-slider-container">
      <Form.Item name={name} label={label} valuePropName={isEnglish ? "checked" : "unchecked"}>
        <Switch
          checkedChildren={<Icon component={fluencyEN} />}
          unCheckedChildren={<Icon component={fluencyPT} />}
          defaultChecked={isEnglish}
          onClick={onLanguageSwitch}
          disabled={disabled}
        />
      </Form.Item>
    </div>
  );
};

export default AdnLanguageSlider;
